module.exports = __webpack_public_path__ + "static/media/gi.74ead24f.svg";